import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";
import {CurrencyDeprecateMode} from "@/modules/redactor/models/currency/CurrencyDeprecateMode";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";

export class CurrencyDeprecate extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(CurrencyDeprecate, v) : SKIP;
            },
            (v) => {
                return deserialize(CurrencyDeprecate, v);
            }
        );
    }

    constructor() {
        super();
        this._mode = CurrencyDeprecateMode.DISABLED;

        this._silent = false;
        this._guard = null;
        this._rewardBunch = null;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get silent() {
        return this._silent;
    }

    set silent(value) {
        this._silent = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get rewardBunch() {
        return this._rewardBunch;
    }

    set rewardBunch(value) {
        this._rewardBunch = value;
    }

    valid() {

        if (this.mode.equal(CurrencyDeprecateMode.DISABLED)) {
            return true;
        } else if (this.mode.equal(CurrencyDeprecateMode.GUARD)) {

            if (!this.guard || this.guard.empty() || !this.guard.valid()) {
                return false;
            }

        } else {
            return false
        }

        if (this.rewardBunch && !this.rewardBunch.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return this.mode.equal(CurrencyDeprecateMode.DISABLED);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CurrencyDeprecate());
        } else if (target instanceof CurrencyDeprecate) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CurrencyDeprecate, {
    _mode: alias("mode", CurrencyDeprecateMode.schema()),
    _silent: alias("silent", Schema.primitive()),

    _guard: alias("guard", GuardConfig.schema()),
    _rewardBunch: alias("reward_bunch", RewardBunch.schema())
});